import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import {
  ManagedSettingsPassCodeLockGracePeriodComponent,
  PassCodeLockGracePeriod,
} from './pass-code-lock-grace-period.component';

@Component({
  selector: 'ml-pass-code-lock-grace-period',
  templateUrl: './pass-code-lock-grace-period.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsPassCodeLockGracePeriodComponent],
})
export class ManagedSettingsPassCodeLockGracePeriodContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  passCodeLockGracePeriod(passCodeLockGracePeriod: PassCodeLockGracePeriod) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.passCodeLockGracePeriod({
        udid: this.udid,
        passCodeLockGracePeriod: passCodeLockGracePeriod.passCodeLockGracePeriod,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
